/**
 * Personal web apps shown in the My Projects section.
 *
 * All three are live sites, so `url` is the source of truth for what a visitor
 * sees — keep the copy here in step with the app itself, not the other way round.
 */

export const WEB_PROJECTS = [
  {
    id: 'pacemotion',
    title: 'PaceMotion',
    subtitle: 'Personal Project',
    tags: ['Nuxt.js', 'Longdo Map', '3D Rendering'],
    url: 'https://ichamp.net/pacemotion/',
    paragraphs: [
      'A browser tool that turns a run into a video. Drop in a GPX, FIT, or TCX file from a watch or a running app, and PaceMotion follows the route across a 3D map with a pace overlay running alongside it, then exports the result as a clip worth sharing.',
      'Everything happens on the device — the activity file never leaves the browser, so there is no account to create and no upload to trust. Sample routes are built in for anyone who wants to see the output before digging up their own data.',
    ],
    screenshot: '/projects/pacemotion.png',
    caption:
      'A running route replayed across a 3D map, with the pace overlay drawn alongside it.',
    toolGroups: [
      {
        title: 'Front-End Development',
        items: [
          ['Framework', 'Nuxt.js (Vue)'],
          ['Rendering', '3D map camera & video export'],
        ],
      },
      {
        title: 'Data & Integration',
        items: [
          ['GIS', 'Longdo Map'],
          ['Activity Files', 'GPX, FIT, TCX — parsed in the browser'],
        ],
      },
    ],
  },
  {
    id: 'offsidefield',
    title: 'OFFSIDE FIELD',
    subtitle: 'Personal Project',
    tags: ['Nuxt.js', 'Longdo Map'],
    url: 'https://offsidefield.ichamp.net/',
    paragraphs: [
      'A map of every Thai League home ground. Each of the 16 clubs gets its stadium plotted with the details that matter to someone planning a trip to a match — where it is, how many it holds, and who plays there.',
      'Built for the football fan rather than the statistician: the fixture list and results sit next to the map, so a stadium, a date, and a scoreline are all reachable from the same screen.',
    ],
    screenshot: '/projects/offsidefield.png',
    caption:
      'Thai League clubs and their home grounds, plotted across the country.',
    toolGroups: [
      {
        title: 'Front-End Development',
        items: [
          ['Framework', 'Nuxt.js (Vue)'],
          ['Content', 'Club directory, fixtures, results'],
        ],
      },
      {
        title: 'Data & Integration',
        items: [
          ['GIS', 'Longdo Map'],
          ['Coverage', '16 Thai League clubs and stadiums'],
        ],
      },
    ],
  },
  {
    id: 'finger-math',
    title: 'Finger Math — คิดเลขเร็ว',
    subtitle: 'Personal Project',
    tags: ['Vue.js', 'Vite'],
    url: 'https://ichamp.net/finger-math/',
    paragraphs: [
      'A mental-arithmetic drill for children and beginners. The app calls out a chain of one- or two-digit additions and subtractions one step at a time, and the player keeps the running total in their head — no calculator, no paper.',
      'A finger-counting mode draws the tens and units on a pair of hands in real time, so a learner can watch the technique instead of only hearing about it. The number of steps and the time allowed per question are both adjustable, and a separate lesson page walks through the counting method from the start.',
    ],
    screenshot: '/projects/finger-math.png',
    caption:
      'A drill in progress, with the finger-counting mode showing tens and units.',
    toolGroups: [
      {
        title: 'Front-End Development',
        items: [
          ['Framework', 'Vue 3'],
          ['Build Tool', 'Vite'],
        ],
      },
      {
        title: 'Product',
        items: [
          ['Practice', 'Randomised step-by-step addition & subtraction'],
          ['Settings', 'Digits, number of steps, time per question'],
          ['Learning Aid', 'Real-time finger-counting mode'],
        ],
      },
    ],
  },
];
